import React, { Component } from 'react'
import './List.css'

class List extends Component {


    render() {

        const { title, items, className } = this.props

        return (

            <div className={className}>

                <div className="list">

                    {/* <hr className='left' /> */}

                    <h3>{title}</h3>

                    <ul>

                        {items.map((item, index) => {
                            return <li key={index}>{item}</li>
                        })}

                    </ul>

                </div>

            </div>


        );
    }
}


export default List;